import type { SlideGrid } from '@/components/NativeSlider/helpers';

export const slideGrid: SlideGrid = {
  desktopL: { cols: 4 },
  desktop: { cols: 3 },
  tablet: { cols: 2 },
  mobile: { cols: 2 },
  mobileS: { cols: 1 },
};

export const MIN_TOURNAMENTS_TO_DISPLAY_SLIDER = 3;
export const MAX_TOURNAMENT_SLIDES_DESKTOP_L = 7;
export const MAX_TOURNAMENT_SLIDES = 5;
